// frontend/src/components/Samples/ProductionTypes.jsx

import React from 'react';
import { productionTypesAPI } from '../../api/client';
import { useTranslation } from '../../context/TranslationContext';
import MasterDataManager from '../Common/MasterDataManager';

const ProductionTypes = () => {
  const { t } = useTranslation();

  const columns = [
    {
      header: t('production_types.type', 'Production Type'),
      field: 'production_type',
      className: 'code-column'
    },
    {
      header: t('production_types.description', 'Description'),
      field: 'description'
    },
    {
      header: t('created_at', 'Created'),
      field: 'created_at',
      render: (row) => new Date(row.created_at).toLocaleDateString()
    }
  ];

  const formFields = [
    {
      name: 'productionType',
      label: 'production_types.type',
      type: 'text',
      required: true,
      maxLength: 20
    },
    {
      name: 'description',
      label: 'production_types.description',
      type: 'text',
      maxLength: 50
    },
    {
      name: 'notes',
      label: 'notes',
      type: 'textarea',
      rows: 3
    }
  ];

  return (
    <MasterDataManager
      title="production_types.title"
      subtitle="production_types.subtitle"
      createButtonLabel="production_types.create"
      api={productionTypesAPI}
      columns={columns}
      formFields={formFields}
      idField="production_type_id"
      displayField="production_type"
    />
  );
};

export default ProductionTypes;